import React from "react";
import { ChevronRight } from "lucide-react";
import { useState } from "react";


const StatusOverview = ({ data, setFilter }) => {

  const bars = [
      { label: "Applied", height: data?.job_counts_all?.applied, color: "#A7C1FF" },
    { label: "Screened", height: data?.job_counts_all?.screened, color: "#B3D4FB" },
    { label: "Interview Scheduled", height: data?.job_counts_all?.["review/interview_scheduled"], color: "#E3D5FF" },
    { label: "Offered", height: data?.job_counts_all?.offered, color: "#FFE29D" },
    { label: "Hired", height: data?.job_counts_all?.hired, color: "#B9E8DF" },
  ];


  const stats = [
    { label: "Pending Applications", value: data?.job_counts_all?.pending_applicant },
    { label: "Review Application", value: data?.job_counts_all?.["review/interview_scheduled"] },
    { label: "Screened Resumes", value: data?.job_counts_all?.screened },
  ];

  const [hovered, setHovered] = useState(null);



  return (
    <div className="first-section-fourth" style={styles.container}>
      <div style={styles.header}>
        <h3 style={styles.title}>Status</h3>
        <div style={styles.filters}>
          {/* <span style={styles.tag}>All</span> */}
          <select
            id="statusFilter"
            name="statusFilter"
            className='dropdown-filter-month'
            onChange={(e) => setFilter(e.target.value)}
            defaultValue="Month"

          >
            <option value="Monthly">Month</option>
            <option value="Weekly">Week</option>
            <option value="Yearly">Year</option>
          </select>
        </div>
      </div>
      <div style={styles.wrapper}>
        <div style={styles.metricsRow}>
          <div style={styles.blueBox}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>

              <span style={styles.blueNumber}>{data.resume_counts_all || 0}</span>
              <ChevronRight size={14} color="black" />
            </div>

            <span style={styles.blueLabel}>Total uploaded resume</span>
          </div>
          {stats.map((item, index) => (
            <div key={index} style={styles.statBox}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={styles.statValue}>{item.value}</span>
                <ChevronRight size={14} color="#000" />
              </div>

              <span style={styles.statLabel}>{item.label}</span>

            </div>
          ))}
        </div>
      </div>
      <div style={styles.barChart}>
        {bars.map((bar, index) => (
          <div key={index} style={{ ...styles.barItem, position: "relative" }}>
            <div
              style={{
                ...styles.bar,
                height: `${bar.height}px`,
                backgroundColor: bar.color,
                position: "relative",
              }}
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
            />
            {hovered === index && (
              <div style={styles.tooltip}>
                {bar.label}: {bar.height}
              </div>
            )}
            <span style={styles.barLabel}>{bar.label}</span>
          </div>

        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 0 8px rgba(0,0,0,0.05)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  title: {
    fontSize: "30px",
    fontWeight: 600,
    fontFamily: "Nunito Sans",
    color: "rgba(0, 0, 0, 0.7)"
  },
  filters: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  tag: {
    background: "#e0f3f2",
    padding: "5px 12px",
    borderRadius: "15px",
    fontSize: "12px",
    color: "#007D7B",
  },
  wrapper: {
    overflowX: "auto",
    Width: "100%"
  },
  metricsRow: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: "30px",
  },
  blueBox: {
    border: "1px solid rgba(94, 150, 255, 1)",
    color: "black",
    padding: "12px 16px",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    position: "relative",
  },
  blueNumber: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  blueLabel: {
    fontSize: "10px",
  },
  statBox: {
    border: "1px solid rgba(94, 150, 255, 1)",
    color: "black",
    padding: "12px",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  statValue: {
    fontSize: "18px",
    fontWeight: 600,
  },
  statLabel: {
    fontSize: "10px",
  },
  barChart: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-around",
    marginTop: "10px",
    maxHeight: "200px"
  },
  barItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    maxHeight: "200px"
  },
  bar: {
    width: "30px",
    borderRadius: "10px",
  },
  barLabel: {
    fontSize: "12px",
    marginTop: "5px",
  },
  tooltip: {
    position: "absolute",
    top: -30,
    backgroundColor: "rgba(94, 150, 255, 1)",
    color: "#fff",
    padding: "4px 8px",
    fontSize: "12px",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    transform: "translateY(-100%)",
    zIndex: 10,
  }

};

export default StatusOverview;
